import PotentitalExportService from "../../services/PotentialExportService";

class PotentialExportManager {
  async getPotentialReport() {
    await PotentitalExportService.getExportPotentialFile().then(response => {
      if (!response || !response.data) {
        return;
      }

      const xlsxPotentialFile = new Blob([response.data], {
        type: response.headers["content-type"]
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(xlsxPotentialFile, "Exportação de potencial");
      } else {
        const URLfile = URL.createObjectURL(xlsxPotentialFile);
        const link = document.createElement("a");
        link.setAttribute("download", "ExportaçãoPotencial.xlsx");
        link.href = URLfile;
        link.click();
      }
    });
  }
}

export default new PotentialExportManager();
